import React from 'react';
import LiveProgramsListingPage from './LiveProgramsListingPage';
export default function LiveGuidancePage() { return <LiveProgramsListingPage type="guidance"/>; }
